import React from 'react';
import Profile from "../components/Profile";

const ProfilePage = () => {
    return (
        <div className={'profile_page_container'}>
            <Profile />
        </div>
    );
};

export default ProfilePage;